import { render } from "./FavoriteCarousel.vue?vue&type=template&id=5c37dd07"
import script from "./FavoriteCarousel.vue?vue&type=script&lang=js"
export * from "./FavoriteCarousel.vue?vue&type=script&lang=js"

import "./FavoriteCarousel.vue?vue&type=style&index=0&id=5c37dd07&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__